module.exports = __webpack_public_path__ + "static/media/The Band CAMINO - Daphne Blue (Official Lyric Video).dbf74f40.mp3";